module.exports = __webpack_public_path__ + "img/logo-business.98050130.svg";